import React from 'react'
import PropTypes from 'prop-types'

const mapSections = sectionGroup => sectionGroup.sections || []

const SectionGroupWrapper = (props) => {
  const { render, sectionGroup } = props

  return render({
    sections: mapSections(sectionGroup),
  })
}

SectionGroupWrapper.propTypes = {
  render: PropTypes.func.isRequired,
  sectionGroup: PropTypes.object.isRequired,
}

export default SectionGroupWrapper
